global.$ = global.jQuery = window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js');
require('bootstrap');

import 'nestable2/dist/jquery.nestable.min.js'
import 'nestable2/dist/jquery.nestable.min.css'

import 'jquery-migrate/dist/jquery-migrate';
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-ui/ui/widgets/datepicker';
import 'jquery-ui/ui/widgets/dialog';
import 'jquery-ui/ui/widgets/draggable';
import 'jquery-ui/ui/widgets/droppable';
import 'jquery-ui/ui/widgets/sortable';
import 'jquery-ui/ui/widgets/tabs';
import 'jquery-ui/ui/widgets/tooltip';
import 'tablesorter/dist/js/jquery.tablesorter.min';
import 'nestable2/jquery.nestable';

import 'gridstack/dist/gridstack.min.css';
import { GridStack } from 'gridstack';
import 'gridstack/dist/h5/gridstack-dd-native';

import * as echarts from 'echarts';

import Echo from 'laravel-echo';

window.Pusher = require('pusher-js');
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: "https://3698be5bd3794465aacce4e9a203fbec@o457102.ingest.sentry.io/5452672",

        // Alternatively, use `process.env.npm_package_version` for a dynamic release version
        // if your build tool supports it.
        integrations: [new Integrations.BrowserTracing()],

        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0,
    });
}
global.GridStack = GridStack;
global.echarts	= echarts;
global.Echo	= Echo;

$(function () {

    $(":input[name=globalsearch]").select2({
        ajax:	{
            url:	"js/json/globalsearch.php",
            data: function (params) {
                return {
                    term:	 				params.term
                };
            },
            processResults:	function(data){
                return data;
            },
            delay: 				250,
            cache: 				true
        },
        minimumInputLength: 3,
        placeholder: "Vind pagina's, relaties, facturen",
        templateResult: function(result){
            var text = '<span class="text">'+result.text+'</span>';
            if(result.subtext){
                text += '<span class="subtext">'+result.subtext+'</span>';
            }
            return $(text);
        },
        language: {
            errorLoading:function(){return"De resultaten konden niet worden geladen."},
            inputTooLong:function(e){var t=e.maximum,n="Vul maximaal "+t+" karakters in";return n},
            inputTooShort:function(e){var t=e.minimum,n="Vul minimaal "+t+" karakters in";return n},
            loadingMore:function(){return"Meer resultaten laden..."},
            maximumSelected:function(e){var t="Er kunnen maar "+e.maximum+" item";return e.maximum!=1&&(t+="s"),t+=" worden geselecteerd",t},
            noResults:function(){return"Geen resultaten gevonden..."},
            searching:function(){return"Zoeken..."}
        }
    }).on("select2:select", function(e){
        var data = e.params.data;
        if(data.url){
            document.location.href=data.url;
        }
    });
});

$(document).ready(function () {
    // Nieuwe reservering: Quicklinks actief maken bij scrollen
    // Nieuwe reservering: Naar content scrollen
    $('.quicklinks a[href^="#"]').on('click', function (e) {
        e.preventDefault();
        $(document).off("scroll");

        // Actieve classes toevoegen en verwijderen
        $('a').each(function () {
            $(this).parent().removeClass('active');
        })
        $(this).parent().addClass('active');

        // Scrollen naar juiste div content
        var target = this.hash;
        var $target = $(target).offset().top;
        $('html, body').stop().animate({
            'scrollTop': $target
        }, 250, function () {
            $(document).on("scroll", onScroll);
        });
    });


    // $(document).on("click", ".togglemenu", function() {
    //     $("#shortcuts, #navbar").toggleClass("show");
    //     $("body").toggleClass("prevent-scrolling");
    //     $(this).toggleClass("menu-active");
    //     let $headerWrapper  = $("#header-wrapper");
    //     let $shortcuts      = $("#shortcuts");
    //     let menuOffset     = $headerWrapper.outerHeight() + $shortcuts.outerHeight();
    //     $("#navbar").css({"top": menuOffset, "padding-bottom": menuOffset});
    // });
    //
    // if($(window).width() < 768) {
    //     let menuActive = $.cookie("active_menu");
    //     $("#navbar > ul > li > a").on("click", function () {
    //         if ($(this).parent().hasClass("active")) {
    //             $(this).parent().removeClass("active");
    //             $.cookie("active_menu", null);
    //         } else {
    //             $(this).parent().addClass("active");
    //             $.cookie("active_menu", $(this).attr("class"));
    //         }
    //     });
    //
    //     if (typeof $.cookie("active_menu") === typeof undefined){
    //         let $activeItem = $("#navbar > ul > li").find('a[class="' + menuActive + '"]');
    //         $activeItem.parent().addClass("active");
    //     }
    // }

    $(window).scroll(function () {
        onScroll();
    });

    // Legena kunnen slepen door pagina, sluiten na klikken op X
    if($("#legenda").length > 0){
        $("#legenda").drags();
        $("#legenda .close").on("click", function () {
            $(this).parent().hide();
        });
    }

    // In select2 mogelijkheid maken om een background te tonen
    $('.multi-select-labels').select2({
        closeOnSelect: false,
        templateResult: function(option){
            var $option	= $(option.element);
            if(typeof $option.attr("data-background-color") !== typeof undefined) {
                var backgroundColor = $option.attr("data-background-color");
                return $("<span><span class='select2-item' style='background-color: "+backgroundColor+";'></span>"+option.text+"</span>");
            }
            return option.text;
        },
        templateSelection: function(option){
            var $option = $(option.element);
            if(typeof $option.attr("data-background-color") !== typeof undefined) {
                var backgroundColor = $option.attr("data-background-color");
                return $("<span><span class='select2-item' style='background-color: "+backgroundColor+";'></span>"+option.text+"</span>");
            }
            return option.text;
        }
    });

    // Relatietype met id 2 + 3 niet wegklikbaar kunnen maken (relatie toevoegen / edit etc)
    let $selectRelType = $("select[name='relation_type[]'");
    if($selectRelType.length > 0 ) {
        $("select[name='relation_type[]'").on("select2:unselecting", function (event) {
            if(event.params.args.data.id == 2 || event.params.args.data.id == 3) {
                event.preventDefault();
            }
        });
    }

    $(".result-wrapper .read-more").on("click", function (){
        $(this).parent().find('.list-group-item').show();
        $(this).hide();
    });

    // De 'Terug' button in de pop-up de huidige pop-up laten sluiten
    $(".terug .btn.terug").on("click", function(ev){
        ev.preventDefault();

        if($("body.popup-ui").length > 0){
            var $closeBtn    = parent.$(".ui-dialog-titlebar-close");
            if($closeBtn.length > 0){
                $closeBtn.trigger("click");
            }
        }

        if(parent && parent.dhxWins){
            var topWindowName   = parent.dhxWins.getTopmostWindow(false);
            if(topWindowName !== null){
                parent.dhxWins.window(topWindowName).close();
            }
        }
    });

    // Pagina als snelkoppeling aan favorieten toe kunnen voegen
    $(".makeshortcut").click(function(){
        var $this	= $(this);
        $.ajax({
            type: "POST",
            url: "js/json/makeshortcut.php",
            data: {
                right_id: 	$this.attr("data-right-id"),
                name:		$this.attr("data-name"),
                conn_id:	$this.attr("data-conn-id")
            },
            success: function(data){
                $.eoprompt(data.message);
                if(data.added && data.added === true){
                    $(".add-to-favorites").addClass("active");
                } else {
                    $(".add-to-favorites").removeClass("active");
                }
            }
        });

        return false;
    });

    /*
     ** Om te voorkomen dat standaard zwart wordt opgeslagen, wordt de input color een tekst veld bij het laden
     *  Daarna wordt na de klik het veld weer een color selector
     */
    if($("input[type='color']").length > 0) {
        $("input[type='color']").each(function () {
            let inputColor = $(this).attr("value");
            if (inputColor === "#" || inputColor === "") {
                // Class nodig, zodat we later op basis van de class het veld leeg kunnen maken
                $(this).attr("value", "").addClass("emptyValue");
            } else {
                $(this).css("background-color", inputColor); // De gekozen kleur als background kleur op de input zetten
                inputClearValue($(this));
            }
            $(this).addClass("input-color").prop("type", "text"); // Verander type color naar type text

            $(this).change(function () {
                inputColorToText($(this));
                inputClearValue($(this));
            });
        });
        $(".input-color.emptyValue").val("");
        $(".input-color").on("click", function () {
            $(this).prop("type", "color").css("background-color", "");
        });
    }

    // Input color type naar text en achtergrond toevoegen + clear button tonen
    function inputColorToText($input) {
        let inputColor = $input.val();
        $input.addClass("input-color").prop("type", "text"); // Verander type color naar type text
        $input.css("background-color", inputColor); // De gekozen kleur als background kleur op de input zetten
    }

    // Button toevoegen om kleur weer uit input veld te verwijderen
    function inputClearValue($input) {
        $input.parent().append("<div title='Kleur leegmaken' class='resetCurrentColor'></div>"); // Reset knop maken zodat input leeg kan worden gemaakt
        let $resetColor = $(".resetCurrentColor");
        if($resetColor.length > 0) {
            $(".resetCurrentColor").on("click", function () {
                $(this).hide().siblings().attr("value", "").val("").css("background-color", ""); // Button verbergen en input leeg maken
            });
        }
    }

    //dummy element om het huidige scherm te focussen
    let $dummyinputfocus    = $("#dummyinputfocus");
    if($dummyinputfocus.length > 0){
        setTimeout(function(){
            $dummyinputfocus.focus();
        }, 50);

        $dummyinputfocus.on("focus", function(){
            $(this).blur();
        });
    }

    // Juiste item actief maken bij scrollen binnen nieuwe reservering pagina
    function onScroll(event){
        var scrollPos = $(document).scrollTop();
        if($(".quicklinks").length > 0) {
            $('.quicklinks a').each(function () {
                var currLink = $(this);
                var refElement = $(currLink.attr("href"));
                if (refElement.length && refElement.position().top <= scrollPos && refElement.position().top + refElement.height() > scrollPos) {
                    $('.quicklinks a').parent().removeClass("active");
                    currLink.parent().addClass("active");
                } else {
                    currLink.parent().removeClass("active");
                }
            });
        }
    }
});

String.prototype.trimLeft = function(charlist) {
  if (charlist === undefined)
    charlist = "\s";

  return this.replace(new RegExp("^[" + charlist + "]+"), "");
};

String.prototype.trimRight = function(charlist) {
  if (charlist === undefined)
    charlist = "\s";

  return this.replace(new RegExp("[" + charlist + "]+$"), "");
};

